var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFinal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 878 948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient);\n      }\n\n      .st4 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st5 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st6 {\n        fill: #ffffff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 273.1,
    y1: 232,
    x2: 439.2,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 439.1,
    cy: 232.5,
    fx: 439.1,
    fy: 232.5,
    r: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -34.9,
    y1: 498.8,
    x2: 131.2,
    y2: 498.8,
    gradientTransform: "translate(474.4 3.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 605.4,
    cy: 502.8,
    fx: 605.4,
    fy: 502.8,
    r: 152,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -367.9,
    y1: 498.8,
    x2: -201.8,
    y2: 498.8,
    gradientTransform: "translate(474.4 3.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 272.4,
    cy: 502.8,
    fx: 272.4,
    fy: 502.8,
    r: 152,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "439.2 97.3 439.2 265.2 273.1 366.7 439.1 97.2 439.2 97.3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "605.7 367.7 604.8 367.7 439.2 265.2 439.2 265.2 439.2 97.3 605.7 367.7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "604.8 367.7 272.5 367.7 273.1 366.7 439.2 265.2 439.2 265.2 604.8 367.7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.5,367.7h0s0,0,0,0h0s41.6-25.7,41.6-25.7l41.6-25.6,41.6-25.6,41.7-25.4-.2.3.2-84.2c0-14,0-28.1,0-42.1v-42.1c0,0,.5,0,.5,0l.2,84.2v84.2s-.2-.4-.2-.4l41.6,25.5,41.5,25.6,41.5,25.6,41.5,25.7h0c0,0-41.7-25.2-41.7-25.2l-41.7-25.4-41.7-25.4-41.6-25.5h-.2c0-.1,0-.4,0-.4v-84.2s.2-84.2.2-84.2h.6v42.1c0,14-.2,28.1-.1,42.1l.2,84.2v.2s-.2.1-.2.1l-41.6,25.6-41.7,25.4-41.7,25.4-41.8,25.3h0s0,0,0,0h0Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "605.6 367.6 605.6 535.4 439.5 637 605.5 367.5 605.6 367.6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "772.1 638 771.1 638 605.6 535.5 605.6 535.4 605.6 367.6 772.1 638",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "771.1 638 438.9 638 439.5 637 605.6 535.4 605.6 535.5 771.1 638",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.8,637.9h0s0,0,0,0h0s41.6-25.7,41.6-25.7l41.6-25.6,41.6-25.6,41.7-25.4-.2.3.2-84.2c0-14,0-28.1,0-42.1v-42.1c0,0,.5,0,.5,0l.2,84.2v84.2s-.2-.4-.2-.4l41.6,25.5,41.5,25.6,41.5,25.6,41.5,25.7h0c0,0-41.7-25.2-41.7-25.2l-41.7-25.4-41.7-25.4-41.6-25.5h-.2c0-.1,0-.4,0-.4v-84.2s.2-84.2.2-84.2h.6v42.1c0,14-.2,28.1-.1,42.1l.2,84.2v.2s-.2.1-.2.1l-41.6,25.6-41.7,25.4-41.7,25.4-41.8,25.3h0s0,0,0,0h0Z",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "272.6 367.6 272.6 535.4 106.5 637 272.5 367.5 272.6 367.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "439.1 638 438.1 638 272.6 535.5 272.6 535.4 272.6 367.6 439.1 638"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "438.1 638 105.9 638 106.5 637 272.6 535.4 272.6 535.5 438.1 638"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.8,637.9h0s0,0,0,0h0s41.6-25.7,41.6-25.7l41.6-25.6,41.6-25.6,41.7-25.4-.2.3.2-84.2c0-14,0-28.1,0-42.1v-42.1c0,0,.5,0,.5,0l.2,84.2v84.2s-.2-.4-.2-.4l41.6,25.5,41.5,25.6,41.5,25.6,41.5,25.7h0c0,0-41.7-25.2-41.7-25.2l-41.7-25.4-41.7-25.4-41.6-25.5h-.2c0-.1,0-.4,0-.4v-84.2s.2-84.2.2-84.2h.6v42.1c0,14-.2,28.1-.1,42.1l.2,84.2v.2s-.2.1-.2.1l-41.6,25.6-41.7,25.4-41.7,25.4-41.8,25.3h0s0,0,0,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.9,475.3c14.5,0,14.6-22.6,0-22.6s-14.6,22.6,0,22.6h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395,715.5h-21l-5.5,11.9h-8l24.2-52,23.4,52h-8.1l-5.1-11.9ZM391.9,708.6l-7.3-16.6-7.6,16.6h14.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,715.5h-21l-5.5,11.9h-8l24.2-52,23.4,52h-8.1l-5.1-11.9ZM446.5,708.6l-7.3-16.6-7.6,16.6h14.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.1,715.5h-21l-5.5,11.9h-8l24.2-52,23.4,52h-8.1l-5.1-11.9ZM501.1,708.6l-7.3-16.6-7.6,16.6h14.9Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260.9,821v21.6h-3.3v-21.6h3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,842.6v-23.1l15.7,16.5v-15h3.3v22.9l-15.7-16.4v15.1h-3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1,824v18.5h-3.3v-18.5h-5v-3.1h13.2v3.1h-5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.4,824h-8.7v5.2h8.4v3.1h-8.4v7.2h8.7v3.1h-11.9v-21.6h11.9v3.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.4,833.4l6.7,9.2h-4l-6.2-8.8h-.6v8.8h-3.3v-21.6h3.8c2.9,0,4.9.5,6.2,1.6,1.4,1.2,2.1,2.8,2.1,4.7s-.4,2.8-1.3,3.9c-.9,1.1-2,1.8-3.5,2.1ZM369.4,830.9h1c3.1,0,4.6-1.2,4.6-3.5s-1.5-3.3-4.5-3.3h-1.2v6.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.8,842.6v-23.1l15.7,16.5v-15h3.3v22.9l-15.7-16.4v15.1h-3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,837.3h-9.2l-2.4,5.2h-3.5l10.7-22.9,10.3,22.9h-3.6l-2.3-5.2ZM442,834.3l-3.2-7.3-3.4,7.3h6.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,824v18.5h-3.3v-18.5h-5v-3.1h13.2v3.1h-5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.6,821v21.6h-3.3v-21.6h3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.2,831.7c0-3,1.1-5.7,3.3-7.8,2.2-2.2,4.9-3.3,8-3.3s5.7,1.1,7.9,3.3c2.2,2.2,3.3,4.8,3.3,7.9s-1.1,5.7-3.3,7.9c-2.2,2.2-4.9,3.3-8.1,3.3s-5.3-1-7.5-2.9c-2.4-2.1-3.7-4.9-3.7-8.4ZM509.5,831.7c0,2.4.8,4.3,2.4,5.9,1.6,1.5,3.4,2.3,5.5,2.3s4.2-.8,5.7-2.3c1.6-1.6,2.3-3.5,2.3-5.8s-.8-4.2-2.3-5.8c-1.5-1.6-3.4-2.3-5.7-2.3s-4.1.8-5.7,2.3c-1.5,1.5-2.3,3.5-2.3,5.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.3,842.6v-23.1l15.7,16.5v-15h3.3v22.9l-15.7-16.4v15.1h-3.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.8,837.3h-9.2l-2.4,5.2h-3.5l10.7-22.9,10.3,22.9h-3.6l-2.3-5.2ZM591.5,834.3l-3.2-7.3-3.4,7.3h6.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,821v18.5h6.3v3.1h-9.6v-21.6h3.3Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.2,756h-19.6v11.8h19.1v6.9h-19.1v16.4h19.6v6.9h-27v-49h27v6.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.4,798v-52.3l35.7,37.4v-34h7.4v51.9l-35.7-37.3v34.3h-7.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.2,756v42h-7.4v-42h-11.3v-6.9h29.9v6.9h-11.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.5,756h-19.6v11.8h19.1v6.9h-19.1v16.4h19.6v6.9h-27v-49h27v6.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,777.1l15.2,20.9h-9l-14-20h-1.3v20h-7.4v-49h8.7c6.5,0,11.1,1.2,14,3.6,3.2,2.7,4.8,6.3,4.8,10.7s-1,6.4-3,8.9c-2,2.5-4.6,4.1-7.9,4.8ZM403.1,771.5h2.3c7,0,10.5-2.7,10.5-8s-3.4-7.5-10.2-7.5h-2.6v15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.7,778.1v19.9h-7.4v-49h8.4c4.1,0,7.2.3,9.3.9,2.1.6,4,1.6,5.6,3.2,2.8,2.7,4.2,6.2,4.2,10.4s-1.5,8-4.5,10.7-7,3.9-12.1,3.9h-3.4ZM448.7,771.2h2.8c6.8,0,10.2-2.6,10.2-7.8s-3.5-7.6-10.5-7.6h-2.4v15.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.5,777.1l15.2,20.9h-9l-14-20h-1.3v20h-7.4v-49h8.7c6.5,0,11.1,1.2,14,3.6,3.2,2.7,4.8,6.3,4.8,10.7s-1,6.4-3,8.9c-2,2.5-4.6,4.1-7.9,4.8ZM490.3,771.5h2.3c7,0,10.5-2.7,10.5-8s-3.4-7.5-10.2-7.5h-2.6v15.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.9,749v49h-7.4v-49h7.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.8,756.3l-6,3.6c-1.1-1.9-2.2-3.2-3.2-3.8-1.1-.7-2.4-1-4.1-1s-3.8.6-5.1,1.7c-1.4,1.1-2,2.6-2,4.3s1.8,4.3,5.3,5.8l4.9,2c4,1.6,6.9,3.6,8.7,5.9,1.8,2.3,2.8,5.2,2.8,8.5s-1.5,8.2-4.5,11.2c-3,3-6.8,4.4-11.3,4.4s-7.8-1.3-10.5-3.8c-2.7-2.5-4.4-6.1-5.1-10.6l7.5-1.6c.3,2.9.9,4.9,1.8,6,1.5,2.1,3.7,3.2,6.7,3.2s4.2-.8,5.7-2.3c1.5-1.5,2.3-3.5,2.3-5.9s-.1-1.8-.4-2.6c-.3-.8-.7-1.5-1.2-2.2-.6-.7-1.3-1.3-2.2-1.9-.9-.6-1.9-1.1-3.2-1.7l-4.7-2c-6.7-2.8-10.1-7-10.1-12.4s1.4-6.8,4.2-9.2c2.8-2.5,6.3-3.7,10.5-3.7s10.1,2.7,13.2,8.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.5,756h-19.6v11.8h19.1v6.9h-19.1v16.4h19.6v6.9h-27v-49h27v6.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.4,756.3l-6,3.6c-1.1-1.9-2.2-3.2-3.2-3.8-1.1-.7-2.4-1-4.1-1s-3.8.6-5.1,1.7c-1.4,1.1-2,2.6-2,4.3s1.8,4.3,5.3,5.8l4.9,2c4,1.6,6.9,3.6,8.7,5.9,1.8,2.3,2.8,5.2,2.8,8.5s-1.5,8.2-4.5,11.2c-3,3-6.8,4.4-11.3,4.4s-7.8-1.3-10.5-3.8c-2.7-2.5-4.4-6.1-5.1-10.6l7.5-1.6c.3,2.9.9,4.9,1.8,6,1.5,2.1,3.7,3.2,6.7,3.2s4.2-.8,5.7-2.3c1.5-1.5,2.3-3.5,2.3-5.9s-.1-1.8-.4-2.6c-.3-.8-.7-1.5-1.2-2.2-.6-.7-1.3-1.3-2.2-1.9-.9-.6-1.9-1.1-3.2-1.7l-4.7-2c-6.7-2.8-10.1-7-10.1-12.4s1.4-6.8,4.2-9.2c2.8-2.5,6.3-3.7,10.5-3.7s10.1,2.7,13.2,8.2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinal);
export default __webpack_public_path__ + "static/media/logo-final.6b6e0b5d6418cdd26d64967d543a6317.svg";
export { ForwardRef as ReactComponent };